import { RequestCommissionChangeCTA } from "@faire/help-center-self-serve/brand/instantAnswers/ctas";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var requestCommissionUpdate = function requestCommissionUpdate(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getRequestCommission;
        return (_getRequestCommission = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission === void 0 ? void 0 : _getRequestCommission.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getRequestCommission2, _getRequestCommission3;
        return (_getRequestCommission2 = getRequestCommissionChangeCTA(context, strictLocalize)) === null || _getRequestCommission2 === void 0 ? void 0 : (_getRequestCommission3 = _getRequestCommission2.getLink) === null || _getRequestCommission3 === void 0 ? void 0 : _getRequestCommission3.call(_getRequestCommission2);
      }
    },
    learnMoreLink: articles !== null && articles !== void 0 && articles.FaireDirect.ORDER_COMMISSION ? articlePage(articles.FaireDirect.ORDER_COMMISSION.id) : undefined
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  var _context$brandOrder, _context$brandOrder$b;
  var brandOrderToken = (_context$brandOrder = _context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (!brandOrderToken) {
    return {
      getTitle: function getTitle() {
        return strictLocalize({
          id: "LNjxMH",
          defaultMessage: [{
            "type": 0,
            "value": "Como atualizar a comissão para 0%"
          }]
        });
      },
      getDescription: function getDescription() {
        return [strictLocalize({
          id: "6NulTy",
          defaultMessage: [{
            "type": 0,
            "value": "Temos todo o gosto em atualizar uma encomenda para 0% de comissão quando facultar documentação sobre a sua relação com um revendedor elegível. Para enviar a documentação, clique em \"Solicitar alteração de comissão\" na página específica da encomenda no portal da marca. Após enviar a documentação, a nossa equipa vai analisar o pedido e enviar-lhe uma atualização por e-mail no prazo de 2 dias úteis."
          }]
        })];
      }
    };
  }
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "fYRs9C",
        defaultMessage: [{
          "type": 0,
          "value": "Como atualizar a comissão desta encomenda para 0%"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "DNYfPe",
        defaultMessage: [{
          "type": 0,
          "value": "Teremos todo o gosto em atualizar uma encomenda para 0% de comissão quando facultar documentação sobre a sua relação com um revendedor elegível. Para enviar a documentação, clique em \"Solicitar alteração de comissão\" na página específica da encomenda no portal da marca ou abaixo. Após o envio, a nossa equipa irá analisar o pedido e enviar-lhe uma atualização por e-mail no prazo de 2 dias úteis."
        }]
      })];
    }
  };
};
var getRequestCommissionChangeCTA = function getRequestCommissionChangeCTA(context, strictLocalize) {
  var _context$brandOrder2, _context$brandOrder2$;
  var brandOrderToken = (_context$brandOrder2 = context.brandOrder) === null || _context$brandOrder2 === void 0 ? void 0 : (_context$brandOrder2$ = _context$brandOrder2.brand_order) === null || _context$brandOrder2$ === void 0 ? void 0 : _context$brandOrder2$.token;
  if (!brandOrderToken) {
    return undefined;
  }
  return RequestCommissionChangeCTA(brandOrderToken, strictLocalize);
};